import YUSPUtil from '../../../core/util/yusp_util';

import {isSoloare, JsEnv} from '../../../core/models/js_env';
import { CategoryMJsEnv } from '../models/category_m_js_env';
import { RrRepository } from '../../../core/repositories/rr_repository';
import { getRrAreaData } from '../../../core/models/rr/rr_util';
import { CategoryMContainer } from '../views/pc/category_m_container';
import { CategoryM } from '../models/category_m';
import { createRrRequestParam } from '../models/rr/set_rr_request';
import { TypedEvent } from '../../../core/typed_event';
import { AddCartModalAction } from '../../../core/actions/add_cart/modal_action';
import LazyUtil from '../../../core/util/lazy_util';
import { cancelLoading, setLoadingTimer } from '../../../core/util/dom_util';

export class CategoryMAction {
  static readonly UPDATE_EVENT = new TypedEvent<CategoryMJsEnv>();
  private static state: CategoryM;
  private static rrRepository: RrRepository;

  static init(env: JsEnv) {
    this.state = new CategoryM(env.PAGE);
    this.rrRepository = new RrRepository();
    const model = this.state.getModel();

    // カゴモーダルの初期化
    AddCartModalAction.init();

    // おすすめ情報設定がOnかつ、他サプカテではない場合、RR取得処理を実行
    if (model.shouldDisplayRecommend && !model.isSupplier) {
      if (window['RR'] !== undefined) {
        if (!isSoloare(env.SITE_TYPE) && model.isFromExternalSite) {
          // 外部流入レコメンドを表示する場合、ローディング中モジュールを表示させるため、
          // タイマーを設定する(RR応答遅延等を考慮し、タイマー満了時にローディングを解除)
          const timeoutId = setLoadingTimer(model.rrAreaProfileM1.placementName);
          model.rrAreaProfileM1.timeoutId = timeoutId;
        }
        window['RR'].jsonCallback = this.renderRr.bind(this);
        this.rrRepository.sendRequestToRrServer(createRrRequestParam(model));
      } else if (model.isFromExternalSite) {
        // RR未定義の場合はRR送信しないため、ローディングモジュールを即解除
        cancelLoading(model.rrAreaProfileM1.placementName);
      }
    }
    // YUSP連携 ユーザーID連携、VIEWイベント
    YUSPUtil.register({
      enableUserId: true,
      enableView: true,
    });
    // YUSPエリアを表示
    YUSPUtil.showYUSPArea({
      enableMOrSCategory: true,
    })

    // 外部ファイルにjsが含まれた場合、実行されるよう
    LazyUtil.enableExternalFileScript();
  }

  private static async renderRr() {
    // 外部流入版RRエリアは、外部流入時のみ表示する
    if(this.state.getModel().isFromExternalSite) {
      const rrDataM1 = await getRrAreaData(this.state.getModel().rrAreaProfileM1)
      this.state.setRrAreaDataM1(rrDataM1.items, rrDataM1.title);
    }

    const rrDataM2 = await getRrAreaData(this.state.getModel().rrAreaProfileM2)
    this.state.setRrAreaDataM2(rrDataM2.items, rrDataM2.title);

    const rrDataM3 = await getRrAreaData(this.state.getModel().rrAreaProfileM3)
    this.state.setRrAreaDataM3(rrDataM3.items, rrDataM3.title);

    return new CategoryMContainer(this.state.getModel());
  }
}
